import { forwardRef, memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import { Button } from '../../../../Controls/Button/index.tsx';
import { useTableContext } from '../../context.tsx';
import type { ActionButtonProps } from './types.ts';

export const ActionButton = memo(
  forwardRef<HTMLButtonElement, ActionButtonProps>(function ActionButton({ children, ...props }, ref) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const { compact } = useTableContext();

    return (
      <Button {...props} iconOnly={!isMobile && !compact} ghost ref={ref}>
        {children}
      </Button>
    );
  }),
);
